import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import * as TbIcons from 'react-icons/tb';
import * as AiIcons from 'react-icons/ai';
import AuthService from "../services/auth.service";
import AxiosService from "../services/axios.service";
const API_PATH = "contacts";

function ViewContact({ history, match }) {

  const [contact, setContact] = useState([]);
  const { id } = match.params;
  const [mod, setMod] = useState(false);
  const [admin, setAdmin] = useState(false);

  const styles = {
    div: {
      whiteSpace: "pre-line"
    }
  }

  useEffect(() => {
    const user = AuthService.getCurrentUser();
    if (user) {
      setMod(user.roles.includes("ROLE_MODERATOR"));
      setAdmin(user.roles.includes("ROLE_ADMIN"));
    }
    AxiosService.get(API_PATH, id).then(x => {
      var contact = x.data;
      setContact(contact);
      console.log(contact);
    });
  }, []);

  return (

    <div>
      <h1 style={{ marginBottom: 25 }}>{contact.agency_contacts_name}</h1>
      <table class="table">
        <div >
          <button style={{ position: 'sticky', left: 0, top: 25, zIndex: 1 }} onClick={() => history.goBack()}><TbIcons.TbArrowBack color='black' size={38} /></button>

        </div>
        <div style={{ position: 'sticky' }}>
          {(mod || admin) && (
            <Link to={`../edit/${id}`} style={{ position: 'relative', left: 0, top: -1, marginTop: 15 }} className="btn btn-sm btn-primary mr-2"> <AiIcons.AiTwotoneEdit size={22} /> </Link>
          )}
        </div>
        <thead>
          <tr>

          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">Title:</th>
            <td>{contact.title}</td>
          </tr>
          <tr>
            <th scope="row">Agency Contacts Name:</th>
            <td>{contact.name}</td>
          </tr>
          <tr>
            <th scope="row">Street Address:</th>
            <td style={styles.div}>
              {contact.street_address}
            </td>
          </tr>
          <tr>
            <th scope="row">City:</th>
            <td>{contact.city}</td>
          </tr>

          <tr>
            <th scope="row">State:</th>
            <td style={styles.div}>{contact.state}</td>
          </tr>

          <tr>
            <th scope="row">Zip</th>
            <td style={styles.div}>{contact.zip}</td>
          </tr>

          <tr>
            <th scope="row">Primary Phone</th>
            <td style={styles.div}>{contact.primary_phone}</td>
          </tr>

          <tr>
            <th scope="row">Secondary Phone</th>
            <td style={styles.div}>{contact.secondary_phone}</td>
          </tr>

          <tr>
            <th scope="row">Fax</th>
            <td style={styles.div}>{contact.fax}</td>
          </tr>

          <tr>
            <th scope="row">Email</th>
            <td style={styles.div}>{contact.email}</td>
          </tr>

          <tr>
            <th scope="row">Agency Name</th>
            <td style={styles.div}>{contact.agency_name}</td>
          </tr>

        </tbody>
      </table>
    </div >
  );

}

export { ViewContact };